import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ParcelOverview} from '../parcel/ParcelOverview';
import {checkPermission} from '../../../functions/functionLibrary';
import {permissions} from '../../../config/permissions';
import {PersonDialogEditForm} from './PersonDialogEditForm';
import {
    useDeletePersonMutation,
    useGetOutlookContactMutation,
    useGetPersonQuery, useLazyGetPersonQuery,
    useUpdateDoInsertPersonMutation
} from '../../../redux/rtk/injectedPersonApi';
import {Person} from '../../functions/GlobalData';
import {useMapper} from '../../hooks/useMapper';
import {Button} from 'primereact/button';
import CustomDialog from '../../global/CustomDialog';
import CustomDataTable, {ColumnObject} from '../../global/CustomDataTable';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {classNames} from 'primereact/utils';
import {LandRegisterOverview} from '../landRegister/LandRegisterOverview';
import {useGetPersonenTypesQuery, useSetStatusMutation} from '../../../redux/rtk/injectedMappingApi';
import {
    getColumnsPerson,
    getFiltersPerson,
    onClickSetSelectionStatus
} from '../../functions/GlobalData';
import {ProjectList} from '../ProjectList';
import {CustomConfirmDialog} from '../../global/CustomConfirmDialog';
import {
    buttonCreatePerson, buttonDeleteSelection, buttonRemoveSelection,
    buttonSelectionActivate,
    buttonSelectionDeactivate, buttonSelectionOutlookExport,
    makeButtonItem
} from '../../global/viewButtonSelection';
import ViewButtons from '../../global/ViewButtons';
import {Menu} from 'primereact/menu';
import {useLazyGetHereAddressQuery} from '../../../redux/rtk/injectedHereAddressApi';
import {setSelectedFeatures} from '../../../redux/slices/GeomonitoringSlice';
import {useGetParcelQuery, useLazyGetParcelQuery} from '../../../redux/rtk/injectedParcelApi';
import {ProcessOverview} from '../process/ProcessOverview';
import {UtilisationOverview} from '../../projectMasterData/utilisation/UtilisationOverview';
import {MeasureOverview} from '../../projectMasterData/measure/MeasureOverview';
import {faPerson} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ProcessUserMapping} from '../process/ProcessUserMapping';
import {useUpdateArrayMappingMutation} from '../../../redux/rtk/injectedProcessApi';
import {useNavigate} from 'react-router-dom';
import {exportCSV} from '../../functions/Global';
import {DataToProject} from '../DataToProject';
import {showMessageOnSuccess} from '../../global/CustomToast';

type Props = {
    projectId: any,
    editable: boolean,
    expandable: boolean,
    hideGlobalFilter: boolean,
    commonData: boolean,
    showParcels: boolean,
    showPersons: boolean,
    showLandRegisters: boolean,
    showShareInfos: boolean,
    showSuggestions: boolean,
    showColumnFilters: boolean,
    hideButtons?: boolean,
    hideAddButton?: boolean,
    processId?: string,
    mapping?: any,
    dataIds?: string[],
    parentId?: string,
    selectable?: boolean,
    multiSelection?: boolean,
    onSelection?: (e: Person[]) => void,
    suggestionData?: boolean,
    scrollHeight?: string,
    className?: string,
    skeletonCount?: number,
    geoData: any,
    changed?: number,
    isDirty?: boolean
    ableToUpdate?: boolean
}
export const PersonOverview = (props: Props): JSX.Element => {

    const navigate = useNavigate();
    const {t} = useTranslation(['common']);

    const dispatch = useAppDispatch();

    const menu = useRef<any>(null);

    const [updateDoInsertPerson, resultUpdateDoInsertPerson] = useUpdateDoInsertPersonMutation();
    const [values, setValues] = useState<any>([]);
    const [selectedValue, setSelectedValue] = useState<Person | undefined>(undefined);
    const [showValue, setShowValue] = useState<boolean>(false);
    const [showCreatePerson, setShowCreatePerson] = useState<boolean>(false);

    const [dataLoaded, setDataLoaded] = useState<boolean>(false);
    const [selection, setSelection] = useState<Person[]>([]);
    const [confirmDialogVisible, setConfirmDialogVisible] = useState<boolean>(false);
    const [skip, setSkip] = React.useState(false);
    const [expandedRows, setExpandedRows] = useState<any>(null);
    const [columns, setColumns] = useState<ColumnObject[]>([]);
    const [returnedData, setReturnedData] = useState<Person>();
    const [filters, setFilters] = useState<any>({});

    const [personTypes, setPersonTypes] = useState<any>([]);

    const personTypesQuery = useGetPersonenTypesQuery({});
    const [deletePerson, resultDeletePerson] = useDeletePersonMutation();
    const [setStatus, resultSetStatus] = useSetStatusMutation();
    const [getOutlookContact, resultGetOutlookContact] = useGetOutlookContactMutation();
    const [skipParcel, setSkipParcel] = React.useState(true);
    const [personIds, setPersonsIds] = useState([]);

    const mappedArray = useMapper(returnedData, values, 'person_id');
    const [triggerPerson, resultPerson, lastPromiseInfoPerson] = useLazyGetPersonQuery();
    const updatedTable = useAppSelector((state: any) => state.importData.importState);
    const [triggerParcel, resultParcel, lastPromiseInfoParcel] = useLazyGetParcelQuery();

    const [showSelectionSachbearbeiter, setShowSelectionSachbearbeiter] = useState<boolean>(false);
    const [showSelectionVerhandler, setShowSelectionVerhandler] = useState<boolean>(false);

    const [showAddPersonToProject, setShowAddPersonToProject] = useState<boolean>(false);

    const [selectedUser, setSelectedUser] = useState<any>(undefined);

    const [isDirty, setIsDirty] = useState<any>(props.isDirty);

    const [updateProcessMapping, resultUpateMapping] = useUpdateArrayMappingMutation();

    useEffect(() => {
        triggerPerson({
            projectId: props.projectId,
            commonData: props.commonData,
            personId: props.dataIds && props.dataIds.length > 0 ? `["${props.dataIds.join('","')}"]` : undefined,
            mapping: props.mapping
        });
        //  console.log(props);
    }, [props, updatedTable]);

    useEffect(() => {
        setIsDirty(props.isDirty);
    }, [props.isDirty]);

    useEffect(() => {
        if (resultUpateMapping.isSuccess) {
            showMessageOnSuccess(t('success'), t('globalData:toasts.userAdded'));
        }
    }, [resultUpateMapping]);

    useEffect(() => {
        if (personTypesQuery.data) {
            setPersonTypes(personTypesQuery.data.map((x: any) => {
                return {label: x.name, value: x.id};
            }));
        }
    }, [personTypesQuery]);

    useEffect(() => {
        if (resultParcel.status == 'fulfilled') {
            const pData = resultParcel.data;
            const kennzArray: any = [];
            pData.forEach((sel: any) => {
                // console.log(sel)
                kennzArray.push(sel.flstkennz);
            });
            dispatch(setSelectedFeatures(kennzArray));

        }
    }, [resultParcel]);

    useEffect(() => {
        if (window.location.hash.indexOf('_') > -1 && resultPerson.data) {
            const hashElements = window.location.hash.split('_');
            if (hashElements.length > 2) {
                const id = hashElements[2];
                const sPerson = resultPerson.data.find((item: Person) => {
                    return item.person_id === id;
                });
                if (sPerson) {
                    setSelectedValue(sPerson);
                    setShowValue(true);
                }
            }
        }
    }, [resultPerson.data]);

    useEffect(() => {
        setColumns(getColumnsPerson(resultPerson.data, t, personTypes, true, props.showSuggestions, props.showParcels, props.showPersons, props.showLandRegisters, props.mapping));
        if (resultPerson.data) {
            const expandedRowsTemp: any[] = [];
            const newArray = JSON.parse(JSON.stringify(resultPerson.data));
            if (props.expandable) {
                newArray.map((r: any) => {
                    if (r.vorgang || r.inanspruchnahme || r.massnahme || r.flurstueck || r.person || r.grundbuch) {
                        if (props.commonData) {
                            r.expandableElement = (<>
                                {r.vorgang && r.vorgang[0] !== null && <ProcessOverview
                                    showParcels={false}
                                    showPersons={false}
                                    showLandRegisters={false}
                                    projectId={props.projectId}
                                    mapping={{person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                    geoData={props.geoData}
                                />}
                                {r.person && r.person[0] !== null && <PersonOverview
                                    showParcels={false}
                                    showPersons={false}
                                    showLandRegisters={false}
                                    showShareInfos={false}
                                    showSuggestions={false}
                                    hideButtons={true}
                                    projectId={props.projectId}
                                    mapping={{map_person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    commonData={props.commonData}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                    geoData={props.geoData}
                                />}
                                {r.flurstueck && r.flurstueck[0] !== null && <ParcelOverview
                                    showPersons={false}
                                    showLandRegisters={false}
                                    showUtilisationInfo={false}
                                    showShareInfos={true}
                                    hideButtons={true}
                                    mapping={{person_id: r.person_id}}
                                    projectId={props.projectId}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    commonData={props.commonData}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                    geoData={props.geoData}
                                />}
                                {r.grundbuch && r.grundbuch[0] !== null && <LandRegisterOverview
                                    showPersons={false}
                                    showParcels={false}
                                    showShareInfos={true}
                                    hideButtons={true}
                                    projectId={props.projectId}
                                    mapping={{person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    commonData={props.commonData}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                    geoData={props.geoData}
                                />}
                                {r.inanspruchnahme && r.inanspruchnahme[0] !== null && <UtilisationOverview
                                    hideButtons={true}
                                    projectId={props.projectId}
                                    mapping={{person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                />}
                                {r.massnahme && r.massnahme[0] !== null && <MeasureOverview
                                    projectId={props.projectId}
                                    editable={false}
                                    expandable={true}
                                    hideButtons={true}
                                    mapping={{person_id: r.person_id}}
                                    hideGlobalFilter={false}
                                    showColumnFilters={false}
                                    skeletonCount={1}/>}
                                {props.projectId === '' &&
                                    <ProjectList projectId={props.projectId} mapping={{person_id: r.person_id}}
                                                 hideGlobalFilter={false} showColumnFilters={true}/>}
                            </>);
                        } else {
                            r.expandableElement = (<div>
                                <PersonOverview
                                    showPersons={false}
                                    showLandRegisters={false}
                                    showShareInfos={false}
                                    hideButtons={true}
                                    projectId={props.projectId}
                                    mapping={{person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    commonData={true}
                                    showParcels={true}
                                    showSuggestions={false}
                                    parentId={r.person_id}
                                    selectable={r.do_insert}
                                    suggestionData={true}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                    geoData={props.geoData}
                                />
                                <LandRegisterOverview
                                    showPersons={false}
                                    showParcels={false}
                                    showShareInfos={true}
                                    hideButtons={true}
                                    projectId={props.projectId}
                                    mapping={{person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    commonData={props.commonData}
                                    showColumnFilters={false}
                                    skeletonCount={1}
                                    geoData={props.geoData}
                                />
                                <ParcelOverview
                                    showPersons={false}
                                    showLandRegisters={false}
                                    showShareInfos={false}
                                    showUtilisationInfo={false}
                                    hideButtons={true}
                                    projectId={props.projectId}
                                    mapping={{person_id: r.person_id}}
                                    editable={false}
                                    expandable={false}
                                    hideGlobalFilter={false}
                                    commonData={props.commonData}
                                    showColumnFilters={false}
                                    geoData={props.geoData}
                                /></div>);
                        }
                    }
                });
                setExpandedRows(expandedRowsTemp);
            }

            setValues(newArray);
            setDataLoaded(true);
            setFilters(getFiltersPerson());
            // setSkip(true);
        }

    }, [JSON.stringify(resultPerson.data)]);

    /*  if (isError) {
        console.log({error});
    }*/
    /* useEffect(() => {
        setSkip(true)
    }, [props.changed]);*/

    useEffect(() => {
        if (typeof returnedData !== 'undefined') {
            setValues(mappedArray);
        }
    }, [returnedData]);

    useEffect(() => {
        if (props.onSelection) {
            props.onSelection(selection);
        }
        let personArray: any = [];
        selection.forEach((sel: any) => {
            //  console.log(sel);
            if (sel) {
                personArray = personArray.concat(sel.person_id);
            }
        });

        setPersonsIds(personArray);
        // setSkipParcel(false);
        // dispatch(setSelectedFeatures(kennzArray));
    }, [selection]);

    useEffect(() => {
        if (personIds.length > 0) {
            triggerParcel({
                projectId: props.projectId,
                mapping: {person_array: personIds},
                commonData: true
            });
        }

    }, [personIds]);

    const hideDialog = () => {
        setConfirmDialogVisible(false);
        setSelectedValue(undefined);
        setSelection([]);
        setShowSelectionSachbearbeiter(false);
        setShowSelectionVerhandler(false);
        setSelectedUser(undefined);
        setShowAddPersonToProject(false);
    };

    const assignPerson = () => {
        updateDoInsertPerson({
            project_id: props.projectId,
            do_insert: false,
            person_id: props.parentId,
            old_person_id: [selection[0].person_id]
        }).then(() => {
        });
        hideDialog();
    };

    const assignUser = () => {
        updateProcessMapping({
            project_id: props.projectId,
            vorgang_id: props.processId,
            mapping_type: 'vorgang_user',
            users: selection.map((item: Person) => {
                return {...selectedUser, person_id: item.person_id};
            })
        });
        hideDialog();
    };

    const getButtons = () => {
        const result: any[] = [];
        if (props.processId) {
            result.push({
                    label: t('globalData:buttons.setSelectionSachbearbeiter'),
                    icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faPerson}/>,
                    disabled: selection.length <= 0,
                    command: onClickSelectionSachbearbeiter
                },
                {
                    label: t('globalData:buttons.setSelectionVerhandler'),
                    icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faPerson}/>,
                    disabled: selection.length <= 0,
                    command: onClickSelectionVerhandler
                });
        } else {
            result.push({
                    label: t('customDataTable:tooltips.exportAsCSV'),
                    icon: 'pi pi-file-export',
                    disabled: false,
                    command: () => {
                        exportCSV(t, values, 'personDataTable', columns);
                    }
                },
                {
                    label: t('globalData:buttons.setSelectionActive'),
                    icon: 'pi pi-pencil',
                    disabled: selection.length <= 0,
                    command: onClickSelectionActivatePersons
                },
                {
                    label: t('globalData:buttons.setSelectionInactive'),
                    icon: 'pi pi-pencil',
                    disabled: selection.length <= 0,
                    command: onClickSelectionDeactivatePersons
                },
                {
                    label: props.projectId ? t('globalData:buttons.removeFromProject') : t('globalData:buttons.deleteSelection'),
                    icon: 'pi pi-trash',
                    disabled: selection.length <= 0,
                    command: onClickDeleteSelectionPersons
                },
                {
                    label: t('globalData:buttons.selectionOutlookExport'),
                    icon: 'pi pi-file-export',
                    disabled: selection.length <= 0,
                    command: onClickSelectionOutlookExport
                });

            if (!props.projectId) {
                result.push({
                    label: t('globalData:buttons.addSelectionToProject'),
                    icon: 'pi pi-pencil',
                    disabled: selection.length <= 0,
                    command: onClickAddPersonToProject
                },);
            }
        }
        return result;
    };

    const onClickCreatePerson = () => {
        setShowCreatePerson(true);
    };

    const onClickSelectionSachbearbeiter = () => {
        setShowSelectionSachbearbeiter(true);
    };

    const onClickSelectionVerhandler = () => {
        setShowSelectionVerhandler(true);
    };

    const onClickSelectionActivatePersons = () => {
        onClickSetSelectionStatus(props.projectId, 0, 'person', selection, t, setStatus);
    };

    const onClickSelectionDeactivatePersons = () => {
        onClickSetSelectionStatus(props.projectId, 1, 'person', selection, t, setStatus);
    };

    const onClickDeleteSelectionPersons = (e: any) => {
        CustomConfirmDialog({
            message: t('globalData:dialogs.deletePersonDialog.' + (selection.length > 1 ? 'plural' : 'singular')),
            header: t('confirmDialog:deleteDialogHeader'),
            translation: t,
            onConfirm: () => {
                for (let i = 0; i < selection.length; i++) {
                    const item = selection[i];
                    deletePerson({
                        project_id: props.projectId ? props.projectId : '',
                        person_id: item.person_id,
                        common_data: true
                    });
                }
            }
        });
    };

    const onClickSelectionOutlookExport = (e: any) => {
        getOutlookContact(selection);
    };

    const onClickAddPersonToProject = (e: any) => {
        setShowAddPersonToProject(true);
    };

    return (
        <>
            <div className={classNames('h-full', props.className)}>
                <CustomDataTable
                    id="personDataTable"
                    className={!props.commonData ? 'temp-data' : ''}
                    header={
                        <div className={'grid'}>
                            <div className={'col'}>
                                <h4 className={'m-0'}>{props.suggestionData ? t('globalData:global.suggestionsHeader') : t('globalData:global.personen')}</h4>
                            </div>
                            {props.hideButtons != true &&
                                <div className={'col flex justify-content-end flex-wrap mb-auto'}>
                                    {props.hideAddButton !== true && <Button type={'button'}
                                                                             className={'p-button-success p-button-icon-only p-button-outlined'}
                                                                             icon={'pi pi-plus'}
                                                                             onClick={onClickCreatePerson}/>}
                                    <div className={'inline mx-2'}>
                                        <Menu model={getButtons()} popup ref={menu} id="popup_menu"/>
                                        <Button className={'p-button-icon-only p-button-outlined'}
                                                icon="pi pi-angle-down"
                                                type="button"
                                                onClick={(event) => {
                                                    if (menu.current) {
                                                        menu.current.toggle(event);
                                                    }
                                                }} aria-controls="popup_menu" aria-haspopup/>
                                    </div>
                                </div>}
                        </div>
                    }
                    columns={columns}
                    customButtons={[{
                        className: 'p-button-danger',
                        icons: [{key: null, value: null, icon: <i className={'pi pi-trash'}/>}],
                        tooltip: t('delete'),
                        tooltipOptions: {position: 'top'},
                        onClick: (data: any) => {
                            CustomConfirmDialog({
                                message: t('globalData:dialogs.deletePersonDialog.singular'),
                                header: t('confirmDialog:deleteDialogHeader'),
                                translation: t,
                                onConfirm: () => {
                                    deletePerson({
                                        project_id: props.projectId ? props.projectId : '',
                                        person_id: data.person_id,
                                        common_data: true
                                    });
                                }
                            });
                        },
                        permitted: props.processId != null ? false : props.projectId ? checkPermission(permissions.editPersons) : checkPermission(permissions.editMasterData),
                    },
                        {
                            icons: [{key: null, value: null, icon: <FontAwesomeIcon icon={faPerson}/>}],
                            tooltip: t('edit'),
                            tooltipOptions: {position: 'top'},
                            onClick: (data: any) => {
                                setIsDirty((prevState: boolean) => {
                                    const url = `/project/${props.projectId}/#globalData_1_${data['person_id']}`;
                                    if (prevState) {
                                        CustomConfirmDialog({
                                            message: t('dialogs.saveChangesMessage'),
                                            header: t('dialogs.saveChangesHeader'),
                                            translation: t,
                                            onConfirm: () => {
                                                navigate(url);
                                            },
                                            rejectClassName: 'float-right p-button-secondary'
                                        });
                                    } else {
                                        navigate(url);
                                    }
                                    return prevState;
                                });
                            },
                            permitted: props.processId != null,
                        }]}
                    editable={props.projectId ? checkPermission(permissions.editPersons) : checkPermission(permissions.editMasterData) && props.editable}
                    scrollHeight={props.scrollHeight}
                    sortable={true}
                    value={values}
                    expandable={props.expandable}
                    expandedRows={expandedRows}
                    paginator={true}
                    paginatorHideAll={true}
                    displayColumnFilter={props.showColumnFilters}
                    selectionMode={props.selectable ? 'checkbox' : undefined}
                    selection={props.selectable ? selection : undefined}
                    onSelectionChange={props.selectable ? (e) => {
                        if (props.multiSelection) {
                            setSelection(e.value);
                        } else {
                            setSelection([e.value[e.value.length - 1]]);
                        }
                    } : undefined}
                    onEditClick={(data: any) => {
                        setSelectedValue(data);
                        setShowValue(true);
                    }}
                    ableToUpdate={props.ableToUpdate != null ? props.ableToUpdate : props.projectId ? checkPermission(permissions.editPersons) : checkPermission(permissions.editMasterData) && !props.processId}
                    ableToDelete={false}
                    filters={getFiltersPerson()}
                    dataloaded={dataLoaded}
                    hideGlobalFilter={props.hideGlobalFilter}
                    skeletonCount={props.skeletonCount}
                />
                {props.suggestionData &&
                    <div>
                        <Button type={'button'} disabled={selection.length <= 0} className={'mt-3'}
                                label={t('globalData:global.assignPerson')} onClick={() => {
                            setConfirmDialogVisible(true);
                        }}/>
                    </div>}
            </div>
            {showValue && <PersonDialogEditForm
                projectId={props.projectId}
                selectedPerson={selectedValue}
                show={showValue}
                setShow={setShowValue}
                setSelectedPerson={setSelectedValue}
                commonData={props.commonData}
                onFinished={(data: Person) => {
                    console.log('finished', data);
                    setReturnedData(data);
                }}
                geoData={props.geoData}
            />}
            <CustomDialog
                header={t('globalData:global.assignPerson')}
                onCancel={hideDialog}
                visible={confirmDialogVisible}
                maximized={false}
                onClick={assignPerson}>
                <div>{t('globalData:global.assignPersonWarning')}</div>
            </CustomDialog>

            <CustomDialog
                header={t('globalData:global.assignSachbearbeiter')}
                onCancel={hideDialog}
                visible={showSelectionSachbearbeiter}
                maximized={false}
                onClick={assignUser}>
                <div>
                    <ProcessUserMapping projectId={props.projectId}
                                        roleName={'Sachbearbeiter'}
                                        onSelection={(selectedId: string) => {
                                            setSelectedUser({
                                                user_id: selectedId,
                                                role_name: 'Sachbearbeiter',
                                            });
                                        }}/>
                </div>
            </CustomDialog>

            <CustomDialog
                header={t('globalData:global.assignVerhandler')}
                onCancel={hideDialog}
                visible={showSelectionVerhandler}
                maximized={false}
                onClick={assignUser}>
                <div><ProcessUserMapping projectId={props.projectId}
                                         roleName={'Verhandler'}
                                         onSelection={(selectedId: string) => {
                                             setSelectedUser({
                                                 user_id: selectedId,
                                                 role_name: 'Verhandler',
                                             });
                                         }}/>
                </div>
            </CustomDialog>
            {showCreatePerson && <PersonDialogEditForm
                projectId={props.projectId}
                show={showCreatePerson}
                setShow={setShowCreatePerson}
                commonData={true}
                geoData={props.geoData}
            />}
            {showAddPersonToProject &&
                <CustomDialog onCancel={hideDialog} visible={showAddPersonToProject} showFooter={true}
                              formName={'person_to_project'}
                              header={t('globalData:global.addToProject')}>
                    <DataToProject projectId={props.projectId} formId={'person_to_project'}
                                   mappingIdName={'person_id'}
                                   selection={selection}
                                   onFinished={hideDialog}/>
                </CustomDialog>}
        </>
    );
};
